import { invariant } from './invariant';

export function scrollToTop() {
  invariant(document.body, 'Missing document.body');
  invariant(document.documentElement, 'Missing document.documentElement');
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
